// extracted by mini-css-extract-plugin
export default {"job-applications":"PrintableJobApplications_job-applications__MG0UV"};